export function CustomTooltip({ position = "top", content, children, className = '', bg = 'bg-gray-700', text = 'text-white' }: {
    position: "top" | "bottom" | "left" | "right"
    content: string
    children: React.ReactNode
    className?: string
    bg?: string
    text?: string
}) {
    const tooltipPositions = {
        top: "bottom-full left-1/2 transform -translate-x-1/2 -translate-y-1",
        bottom: "top-full left-1/2 transform -translate-x-1/2 translate-y-1",
        left: "right-full top-1/2 transform -translate-y-1/2 -translate-x-1",
        right: "left-full top-1/2 transform -translate-y-1/2 translate-x-1",
    };

    return (
        <div className={`relative group cursor-pointer ${className}`}>
            {children}
            <div
                className={`absolute ${tooltipPositions[position]} w-max max-w-60  hidden group-hover:block ${bg} ${text} text-sm rounded-md px-2 py-1 z-10`}
            >
                {content}
                <div
                    className={`absolute ${position === "top"
                        ? "bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1"
                        : position === "bottom"
                            ? "top-0 left-1/2 transform -translate-x-1/2 -translate-y-1"
                            : position === "left"
                                ? "right-0 top-1/2 transform -translate-y-1/2 translate-x-1"
                                : "left-0 top-1/2 transform -translate-y-1/2 -translate-x-1"
                        } w-2 h-2 ${bg} rotate-45`}
                />
            </div>
        </div>
    );
};
